
import { defineComponent, onMounted, PropType } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import ScrollHint from 'scroll-hint'
import '../../../node_modules/scroll-hint/css/scroll-hint.css'
import { isTouchDevice } from '@/utils/commonMethods'

type HospitalsDetailProgramTableProps = {
  id: string
  weeks: string
  text: string
}[]

export default defineComponent({
  name: 'HospitalsDetailProgramTable',
  props: {
    data: {
      type: Array as PropType<HospitalsDetailProgramTableProps[]>,
      default: () => []
    }
  },

  setup(props) {
    const scrollAnime = onMounted(() => {
      new ScrollHint('.hospitalsDetailProgramTable', {
        i18n: {
          scrollable: '横スクロールで表示'
        }
      } as any)
    })

    onMounted(() => {
      const table = document.querySelector('#js-hospitalsDetailProgramTable')
      const tableHead = table?.querySelector('thead')
      let tableHeight = 0
      let tablePosition = 0
      let lastTime = 0

      const setTableInfo = () => {
        tableHeight = table ? table.clientHeight : 0
        tablePosition = table
          ? table.getBoundingClientRect().top + window.pageYOffset
          : 0
      }
      setTableInfo()

      const fixTableHeader = () => {
        const now = Date.now()
        if (now - lastTime < 10) return
        lastTime = now

        if (!tablePosition || !tableHeight) return

        if (
          window.pageYOffset >= tablePosition &&
          window.pageYOffset <= tablePosition + tableHeight
        ) {
          if (tableHead) {
            const diff = window.pageYOffset - tablePosition
            tableHead.style.top = diff + 'px'
          }
        } else {
          tableHead?.setAttribute('style', '')
        }
      }
      document.addEventListener('scroll', fixTableHeader)
      window.addEventListener('resize', setTableInfo)

      onBeforeRouteLeave(() => {
        document.removeEventListener('scroll', fixTableHeader)
        window.removeEventListener('resize', setTableInfo)
      })
    })

    return {
      scrollAnime,
      isTouchDevice
    }
  }
})
